import BuildingType from '@/roc/building/BuildingType';
import Effects from '@/roc/effects/Effects';
import ProductionCurrency from '@/roc/effects/Production/ProductionCurrency';
import ProductionOutputType from '@/roc/effects/Production/ProductionOutputType';
import ProductionQueue from '@/roc/effects/Production/ProductionQueue';
import ProductionWorkforce from '@/roc/effects/Production/ProductionWorkforce';
import ProductionCost from '@/roc/effects/Production/ProductionCost';
import ProductionDuration from '@/roc/effects/Production/ProductionDuration';
import ProductionOutput from '@/roc/effects/Production/ProductionOutput';

const School = {
  id: '30',
  name: 'School',
  width: 3,
  height: 3,
  type: BuildingType.COLLECTABLE,
  era: 'bronzeAge',
  icon: 'School',
  minLevel: 1,
  maxLevel: 40,
  url: 'https://riseofcultures.wiki.gg/wiki/Buildings/School',
  flags: 0,
  counts: null,
  effects: Effects.create([
    new ProductionQueue(
      ProductionWorkforce.asCallbackWithLevel(
        (level) => {
          if (level === 1) {
            return 1;
          }
          if (level <= 5) {
            return 2;
          }
          if (level <= 9) {
            return 3;
          }
          if (level <= 13) {
            return 4;
          }
          if (level <= 17) {
            return 5;
          }
          if (level <= 21) {
            return 6;
          }
          if (level <= 25) {
            return 7;
          }
          if (level <= 29) {
            return 8;
          }
          if (level <= 33) {
            return 9;
          }
          if (level <= 37) {
            return 10;
          }
          return 11;
        }
      ),
      [
        ProductionCost.asCallbackWithLevel(
          (level) => {
            if (level <= 10) {
              return 2500 * level;
            }

            return 50000 + ((level - 11) * 20000);
          }
        ).withCurrency(ProductionCurrency.GOLD),
      ],
      ProductionDuration.asFlat(8 * 60 * 60),
      ProductionOutput.asCallbackWithLevel(
        (level) => {
          if (level <= 10) {
            return [1.05, 2.1, 2.25, 2.45, 2.55, 3.55, 3.7, 3.95, 4.1, 4.65][level - 1];
          }

          return 5 + (level - 11);
        }
      ).withOutput(ProductionOutputType.RESEARCH_POINTS),
    ),
  ]),
};

export default School;
